import { Smartphone } from "lucide-react";

const RemoteTileDesign = {
  id: "remote",
  icon: Smartphone,
  label: "Controllers",
  background: "#5F7D4D",
  color: "#ffffff",
};

export default RemoteTileDesign;
